import React, {useEffect, useState} from 'react';
import { Form, Select, DatePicker, Button } from 'antd';
import {getBrandsAsSelect} from '../../../services/serviceBrand';

const {RangePicker} = DatePicker;

const BrandFilters = ({updateSignal, updateSelectedBrand}) => {
    const [brands, setBrands] = useState([]);
    const {form} = Form.useForm();

    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map(item => {
                        return {label: item.label, value:item.key, key:item.key}
                    })
                    setBrands(structured);
                }
            })
    }, []);

    const onFormSubmit = (fields) => {
        const {dateRanges, brandId} = fields;
        updateSignal(brandId, dateRanges);
    };

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    };


    return(
        <React.Fragment>
              <Form form={form} layout='inline' onFinish={onFormSubmit}>
                <Form.Item name={'brandId'}>
                    <Select 
                        showSearch 
                        style={{minWidth: '150px'}} 
                        placeholder={'Marka'} 
                        options={brands} 
                        filterOption={selectSearch} allowClear
                    />
                </Form.Item>
                <Form.Item name={'dateRanges'}>
                    <RangePicker format='DD/MM/YYYY' style={{maxWidth: '250px'}}/>
                </Form.Item>
                <Form.Item>
                    <Button htmlType='submit' type='primary'>Güncelle</Button>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
};

export default BrandFilters;